import { Retention } from '@api'
import { z } from 'zod'

export const schema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, 'This field is required'),
  amount: z.number().min(1, 'This field is required'),
  retention: z.nativeEnum(Retention),
  typeId: z.number(),
})

export type FormValues = z.infer<typeof schema>
